import { v4 as uuidv4 } from 'uuid'

import events$ from '@/services/Events'
import loading$ from '@/services/Loading'

import useBasket from '@/hooks/useBasket'
import useLogger from '@/hooks/useLogger'
import useSession from '@/hooks/useSession'

import { STORAGE_KEY } from '@/config/constants'
import { EVENT_OVP } from '@/config/events'

// HOOKS
const { persistBasket } = useBasket()
const { logError, logInfo } = useLogger()
const { resumeSession, setSession } = useSession()

// DATA
let eventHandler = false

// METHODS
function registerSync() {
  // i'm new here, can you please give me a name?
  if (!window.name) {
    window.name = uuidv4()
  }

  eventHandler = handleChangeEvent
  window.addEventListener('storage', eventHandler)

  logInfo('SYNC REGISTERED')
}

function unregisterSync() {
  window.removeEventListener('storage', eventHandler)
  eventHandler = false

  logInfo('SYNC UNREGISTERED')
}

async function handleChangeEvent(event) {
  if (event.key !== STORAGE_KEY) return
  if (event.newValue === null) return

  const oldData = JSON.parse(event.oldValue)
  const newData = JSON.parse(event.newValue)

  // already newest state => abort!
  if (oldData?.updateDate === newData?.updateDate) return

  try {
    loading$.start()

    const __basket = await syncSession(newData)

    logInfo('SESSION SYNCED')
    events$.emit(EVENT_OVP.SYNC_EXECUTED)

    // If the basket is secured, we need to reload. Just to be safe...
    if (__basket.mobile && __basket.email) window.location.reload()

    loading$.end()
  } catch (error) {
    logError(['Failed to sync session after local storage update\n', error, event.oldValue, event.newValue])
    return error
  }
}

async function syncSession(basketFromStorage) {
  const __basket = await resumeSession(basketFromStorage)

  await setSession(__basket, { hot: true, setOwner: false })
  await persistBasket(__basket)

  return __basket
}

export default function useSync() {
  return {
    registerSync,
    unregisterSync,
  }
}
